import { IAccountTable, IFormattedAccount } from 'models/Account';
import { IGetSalesforceAccountResponse } from 'models/SalesforceAccount';
import { get } from 'lodash';

interface LookUpItem {
    name: string;
}

export const formatToTableStructure = (
    acc: IFormattedAccount,
    regionsLookUp: Record<number, LookUpItem>,
    dataLocationsLookUp: Record<number, LookUpItem>,
    salesforceAccounts: IGetSalesforceAccountResponse[]
): IAccountTable => {
    const salesforceObject = salesforceAccounts.find((account) => account.ID === acc.salesforceId);

    return {
        ...acc,
        region: regionsLookUp[acc.regionId]?.name,
        dataLocation: dataLocationsLookUp[acc.dataLocationId]?.name,
        csmName: get(salesforceObject, 'CSM', '') as string,
        seName: get(salesforceObject, 'SalesEngineer', '') as string,
        isActive: acc.active === 1 ? 'Yes' : 'No',
    };
};
